import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useNavigate } from 'react-router-dom';
export const ActionConfirmation = ({ open, setOpen, header, message, onConfirmation, redirectUrl }) => {
    const navigate = useNavigate();
    const handleCancel = () => {
        setOpen(false);
    };
    const handleConfirm = () => {
        onConfirmation();
        setOpen(false);
        redirectUrl && navigate(redirectUrl);
    };
    return (_jsxs(Dialog, { open: open, onClose: handleConfirm, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", children: [_jsx(DialogTitle, { id: "alert-dialog-title", children: header }), _jsx(DialogContent, { children: _jsx(DialogContentText, { id: "alert-dialog-description", children: message }) }), _jsxs(DialogActions, { children: [_jsx(Button, { variant: "outlined", onClick: handleCancel, children: "Cancel" }), _jsx(Button, { variant: "contained", onClick: handleConfirm, autoFocus: true, children: "Confirm" })] })] }));
};
